<template>
    <aside class="settings-content settings-domain-edit">
        <Scrollbar>
            <div class="title">Domain</div>
            <div class="desc">Elevate your creator storefronts with a custom subdomain, delivering an enhanced and more
                seamless shopping experience along with re-marketing and performance tracking opportunities.</div>
            <!-- <Alert v-if="is_merchant_host">You must follow the correct setup with your domain provider</Alert> -->
            <Alert v-if="!is_merchant_host && permission_domain" svgName="lock" className="yellow" :text="contact_us_mail_text"></Alert>

            <div class="info info-yellow" v-if="is_merchant_host && is_domain_work !== 1">
                <p>Your creator storefronts are temporarily running on a Motom domain until your custom subdomain has been
                    added and CNAME record is live.</p>
            </div>

            <!-- <!sub> -->
            <ShowBox v-show="!is_edit_subdomain" :data="Motom_subdomain" :is_loading="is_loading"
                :is_dark="!is_merchant_host" :is_subdomain="true" @open="open" />

            <div v-show="is_edit_subdomain" class="domain domain-edit" :class="{ 'is-loading': is_loading }">
                <label class="label">Connect a custom domain<svg-icon name="close"
                        @click="is_edit_subdomain = false" /></label>

                <div class="domain-edit-small-box">
                    <div class="flex">
                        <div class="sub-url">
                            {{ makeUrl(domain_data.anchor_page_subdomain) }}
                        </div>
                        <div class="domain-edit-small-box-bottom" :key="key_refrash">
                            <span :class="[state_light]" @click="retrySubdomainCheck">{{ status_text
                            }}</span>
                            <el-button @click="handleSubEdit">Edit</el-button>
                        </div>
                    </div>

                    <div class="info info-yellow" v-if="is_domain_work !== 1">
                        <p v-html="subdomain_yellow_text"></p>
                    </div>
                </div>

                <div class="bottom">
                    <p class="peport">
                        <!-- <router-link :to="'/help'">Report issue</router-link> -->
                        <a v-if="$store.state.projectName !== 'cj'" :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Report issue&amp;body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`" target="_blank">Report issue</a>
                        <a v-else href="#" @click.prevent="EventBus.emit('open-global-drawer', 'help-support')">Report issue</a>
                    </p>
                    <div class="dis-connent" @click="handleSubDisconnet">Disconnect Domain</div>
                </div>
            </div>
            <!--sub steup-->
            <div v-show="domain_data.anchor_page_subdomain && is_merchant_host" class="domain p16-24"
                :class="{ 'is-loading': is_loading }">
                <label class="label required">CNAME setup</label>

                <div class="detail" id="detail-box">

                    <p class="black-text">Configure your custom subdomain by adding the CNAME record using the instructions
                        below.</p>
                    <div class="host-wrap">
                        <div :class="['value']" v-for="(v, k) in setup_list" :key="k">
                            <label>{{ v.name }}</label>
                            <div class="value-wrap overflow-text" @click="copy(v, k)" :style="[(k == 0 || k == 3) && `width:${table_weight / 6}px`, (k == 1 || k == 2) && `width:${table_weight / 6 * 2}px`,]">
                                <div v-if="$ProjectName === 'sephora' && v.name === 'Host name'">
                                    creators.sephora.com
                                </div>
                                <div v-else :class="['overflow-text', { 'green-dot': k == 3 && is_domain_work === 1, 'yellow-dot': k == 3 && is_domain_work === 2, 'red-dot': k == 3 && is_domain_work === 3 }]">
                                    {{ v.value.replace(/^(https?:\/\/)/, '') }}
                                </div>
                                <el-button v-show="k == 1 || k == 2" size="small" :style="'border'">Copy</el-button>
                            </div>
                        </div>
                    </div>

                    

                    <DomainOl :domain_ol="domain_ol" />
                    <DomainCnameBtn v-if="is_domain_work == 3" :domain_ol="domain_ol" :setup_list="setup_list"
                        @callApi="retrySubdomainCheck" />
                </div>
            </div>


            <!-- <!fallback> -->
            <ShowBox v-show="!is_edit_url" :data="Motom_Fallback_URL" :is_loading="is_loading" @open="open" :is_dark="!is_merchant_host" :is_fallback="true" />

            <div v-show="is_edit_url" class="domain domain-edit" :class="{ 'is-loading': is_loading }">
                <div class="title">
                    <label class="label label-no-required">{{ pre_redirect_url ? 'Edit' : 'Add' }} fallback URL</label>
                    <!-- <svg-icon name="close" @click="is_edit_url = false" /> -->
                </div>
                <p>It’s the backup URL, that is used when the traffic cannot reach the main domain for some reasons (filter,
                    cap, if your server is down). Fallback URLs allow you to define alternative URLs for failed network
                    requests.</p>
                <div :class="['input', domain_data.redirect_url_err && 'input-err']"><input type="text"
                        placeholder="https://fallback.website.com" v-model="domain_data.redirect_url" /></div>
                <div class="err-msg" v-if="domain_data.redirect_url_err">{{ domain_data.redirect_url_err }}</div>
                <div class="btn-wrap bottom">
                    <div class="dis-connent fallback-dis-connent" @click="openConfirm({step:2})">Remove Fallback URL</div>
                    <div>
                        <el-button type="primary" text  @click="cancelEditFallback">Cancel</el-button>
                        <el-button type="primary" 
                            :key="(pre_redirect_url === domain_data.redirect_url)"
                            :disabled="pre_redirect_url === domain_data.redirect_url || !permission_domain" @click="save('fallback')">{{
                                pre_redirect_url ? 'Save' : 'Add' }}</el-button>
                    </div>
                </div>

            </div>

            <p class="peport">
                <a v-if="$store.state.projectName !== 'cj'" :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Report issue&amp;body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`" target="_blank">Report issue</a>
                <a v-else href="#" @click.prevent="EventBus.emit('open-global-drawer', 'help-support')">Report issue</a>
                <!-- <router-link :to="'/help'">Report issue</router-link> -->
            </p>
        </Scrollbar>
    </aside>

    <SubDomainPop ref="sub" @Continue="openConfirm" :setup_list="setup_list" @Copy="copy" @newSubDomain="callSave" 
        :is_loading_out="is_loading" :domain_ol="domain_ol" :sub_url="makeUrl(domain_data.anchor_page_subdomain)"
        :pre_redirect_url="pre_redirect_url"
        @setSubdomainCheck="setSubdomainCheck" />

    <DomainConfirm ref="confirm" :sub_url="makeUrl(domain_data.anchor_page_subdomain)" @newSubDomain="callSave" @delFallBack="save('del_fallback')"/>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Alert from '@/components/settings/SettingAlert.vue';
import copyToClipboard from 'copy-to-clipboard';
import * as yup from 'yup';
import ShowBox from '@/components/settings/Domain/DomainEditShowBox.vue';
import SubDomainPop from '@/components/settings/Domain/SubDomainPop.vue';
import DomainConfirm from '@/components/settings/Domain/DomainConfirm.vue';
import DomainOl from '@/components/settings/Domain/DomainOl.vue';
import DomainCnameBtn from '@/components/settings/Domain/DomainCnameBtn.vue';
import { ElButton } from 'element-plus';

export default {
    name: 'DomainEdit',

    components: {
        Field,
        Form,
        ElButton,
        Dropdown,
        Scrollbar,
        Alert,
        ShowBox,
        SubDomainPop,
        DomainConfirm,
        DomainOl,
        DomainCnameBtn,
    },

    data() {
        return {
            is_edit_subdomain: false,
            is_edit_url: false,
            is_loading: false,
            is_merchant_host: false,
            is_storefront_actived: 0,
            domain_data: {
                main_domain: '',
                redirect_url: '',
                value: '',
                anchor_page_subdomain: '',
            },
            anchor_page_subdomain_temp: '',
            redirect_url_temp:'',

            pre_main_domain: '',
            pre_redirect_url: '',
            contact_us_mail_text: ``,
            setup_list: [
                {
                    name: 'Type',
                    value: 'CNAME'
                },
                {
                    name: 'Host name',
                    value: ''
                },
                {
                    name: 'Value',
                    value: ''
                },
                {
                    name: 'Status',
                    value: ''
                },
            ],
            domain_ol: [
                'Log in to the domain provider for your website and navigate to the DNS / domain settings.',
                'Add a CNAME type record and paste the above into the appropriate fields. ',
                'Make sure to hit save (or the equivalent).',
                'Allow up to 48 hours for the subdomain to finish configuring.  The status will change once detected.',
            ],
            status_text_list: {
                no_pay: 'Not available under current plan',
                cn_not_set: 'CNAME not set up yet',
                waiting: 'Configuring',
                err: 'Error finding CNAME',
                work: 'Working',
                ssl_work: 'Working & Secure'
            },
            key_refrash: 0,
            status_text: '',
            table_weight: 0

        }
    },

    computed: {
        permission_domain(){
            return this.$store.state.user_data?.permission_list?.settingIntegrations?.domainSettings.permission===100;
        },
        merchant() {
            return this.$store.state.user_data.merchant_account;
        },

        is_domain_work() {
            //null==no,1==green,2==yellow,3==red
            if (this.status_text.includes(this.status_text_list.work)) {
                return 1;
            } else if (this.status_text === this.status_text_list.err || this.status_text === this.status_text_list.cn_not_set) {
                return 3;
            } else if (this.status_text === this.status_text_list.no_pay) {
                return null;
            } else {
                return 2;
            }
        },

        state_light() {
            return { 'green-dot': this.is_domain_work === 1, 'yellow-dot': this.is_domain_work === 2, 'red-dot red-dot-btn-in': this.is_domain_work === 3 };
        },

        Motom_subdomain() {

            return {
                title: 'Connect a custom subdomain',
                desc: '',
                url: this.domain_data.anchor_page_subdomain,
                default_url: 'Example: www.creators.mystore.com',
                act_text: this.status_text,
                is_act: this.is_domain_work,
                is_btn: !this.domain_data.anchor_page_subdomain,
                btn_text: this.domain_data.anchor_page_subdomain ? 'Edit' : 'Add'
            }
        },

        Motom_Fallback_URL() {
            return {
                title: 'Fallback URL',
                desc: 'The fallback URL is the destination where shoppers will go if they cannot reach a creator storefront for any reason (i.e. invalid URLs, failed network requests, or disabled/inactive storefronts).',
                url: this.domain_data.redirect_url,
                default_url: 'Example: www.mystore.com',
                act_text: this.status_text,
                is_act: this.is_domain_work,
                is_btn: true,
                btn_text: this.domain_data.redirect_url ? 'Edit' : 'Add'
            }
        },

        subdomain_yellow_text() {
            if (this.status_text === this.status_text_list.cn_not_set) {
                return `Please confirm that you have added the CNAME record to your DNS below.`
            } else {
                return `Connection in Progress<br>It can take up to 48 hours to finish the connection process depending on your domain provider.`
            }
        }

    },

    methods: {
        listenWidth() {
            const myDiv = document.getElementById('detail-box');

            const observer = new ResizeObserver(entries => {
                for (const entry of entries) {
                    this.table_weight = entry.contentRect.width;
                }
            });
            observer.observe(myDiv);
        },

        start() {
            if (this.$store.state.user_data) {
                this.domain_data.main_domain = this.merchant.main_domain;
                this.domain_data.redirect_url = this.merchant.redirect_url;
                this.domain_data.value = this.merchant.cname_record;
                this.domain_data.anchor_page_subdomain = this.merchant.anchor_page_subdomain;
                //this.domain_data.anchor_page_subdomain = '';
                this.pre_redirect_url = this.merchant.redirect_url;
                this.pre_main_domain = this.merchant.main_domain;

                //now status have this.status_text_list
                this.status_text = this.merchant.anchor_page_subdomain_status_text;
                //this.status_text = this.status_text_list.work;

                this.setup_list[1].value = this.domain_data.anchor_page_subdomain.replace(/^(https?:\/\/)/, '');
                this.setup_list[2].value = this.merchant.cname_record;
                this.handleTableStatus();

                let mail_subject = `${this.merchant.merchant_display_name} - Upgrade to Custom Subdomain`;
                let mail_body = 'Please provide your name and contact info. A representative will contact you in 1-2 business days.';
                if (this.$store.state.projectName === 'cj') {
                    this.contact_us_mail_text = `Want to upgrade to a custom subdomain? <span><a href="#" class="js-open-support-cj">Contact us</a>.</span>`;
                    this.$nextTick(() => {
                        const el = document.querySelector('.js-open-support-cj');
                        if (el) el.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.EventBus.emit('open-global-drawer', 'help-support');
                        });
                    });
                } else {
                    this.contact_us_mail_text = `Want to upgrade to a custom subdomain? <span><a href="mailto:${this.$store.state.mail_to_creator}?subject=${encodeURIComponent(mail_subject)}&body=${encodeURIComponent(mail_body)}" target="_blank">Contact us</a>.</span>`;
                }
                // this.contact_us_mail_text = `Want to upgrade to a custom subdomain? <span><a href="javascript:void(0);" class="notify-link">Contact us</a>.</span>`
            }

            this.listenWidth();
            // this.$ajax('/creator/creator-list-statistic', {
            //     method: 'get',
            //     withCredentials: true,
            // }).then(res => {
            //     this.is_storefront_actived = res.data.data.total_storefront_active_count;
            // });
        },

        makeUrl(url) {
            return (url.startsWith('https://')
                || url.startsWith('http://')) ? url
                : 'https://' +
                url;
        },

        open(v) {
            if (!this.is_merchant_host) return;
            if (v === this.Motom_subdomain.title) {
                if (this.domain_data.anchor_page_subdomain) {
                    this.is_edit_subdomain = true;
                } else {
                    this.openSubPop(1);
                }
            } else if (v === this.Motom_Fallback_URL.title) {
                this.is_edit_url = true;
                this.redirect_url_temp=this.domain_data.redirect_url;
            }
        },

        handleSubEdit() {
            if (this.is_domain_work === 1) {
                this.openSubPop(3);
            } else {
                this.openSubPop(1)
            }
        },

        handleSubDisconnet() {
            if (this.is_domain_work === 1) {
                this.openSubPop(4);
            } else {
                this.openConfirm({ step: 1 })
            }
        },

        openSubPop(num) {
            this.$refs.sub.open(num);
        },

        openConfirm(val) {
            this.$refs.confirm.open(val);
        },

        copy(text, k) {
            if (this.$ProjectName === 'sephora' && k === 1) {
                copyToClipboard('creators.sephora.com', { format: 'text/plain' });
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> ${text.name} copied`);
            } else if (k === 1 || k === 2) {
                copyToClipboard(text.value.replace(/^(https?:\/\/)/, ''), { format: 'text/plain' });
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> ${text.name} copied`);
            };
        },

        callSave(url, redirect_url = '') {
            this.anchor_page_subdomain_temp = url;
            let type = url ? 'change' : 'del';
            this.save(type, redirect_url);
        },

        changeSta(text) {
            this.$store.state.user_data.merchant_account.anchor_page_subdomain_status_text = text;
            this.status_text = text;
            this.handleTableStatus();
        },

        cancelEditFallback(){
            this.is_edit_url = false;
            this.domain_data.redirect_url=this.redirect_url_temp;
        },

        save(type, redirect_url = '') {

            let form_data = new FormData();
            let msg = '';
            let is_error = false;
            const pattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/i;
            let schema = null;
            let which = 'Domain URL'

            form_data.append('main_domain', this.domain_data.main_domain);
            //clean_redirect_url=1(now did not use)

            if (redirect_url) {
                form_data.append('redirect_url', redirect_url);
                this.domain_data.redirect_url = redirect_url;
                this.pre_redirect_url = redirect_url;
            } else if (this.domain_data.redirect_url && type !== 'del_fallback') {
                form_data.append('redirect_url', this.domain_data.redirect_url);
            }

            //del_fallback
            if (type === 'fallback') {
                schema = yup.object().shape({
                    url: yup.string().matches(pattern, 'The url format is incorrect.'),
                });
                if (this.domain_data.redirect_url) schema.validate({ url: this.domain_data.redirect_url, }).catch((err) => {
                    this.domain_data.redirect_url_err = err.message;
                    is_error = true;
                });
                which = 'Fallback URL ';
            }
            else if (type === 'del_fallback') {
                form_data.append('clean_redirect_url', 1);
                which = 'Fallback URL ';
            }
            else if (type === 'change') {
                form_data.append('anchor_page_subdomain', this.anchor_page_subdomain_temp);
            }
            else if (type === 'del') {
                form_data.append('clean_anchor_page_subdomain', 1);
            }
            else {
                form_data.append('anchor_page_subdomain', this.domain_data.anchor_page_subdomain);
            }

            msg = which + (this.pre_redirect_url ? ' updated' : ' added');


            this.domain_data.redirect_url_err = '';

            setTimeout(() => {
                if (is_error) return;
                this.is_loading = true;

                this.$ajax(`/settings/update-domain`, {
                    method: 'post',
                    data: form_data
                }).then(res => {
                    this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + msg);
                    let data = res.data.data
                    // this.is_update_redirect_url = true;

                    if (data) {
                        console.log('data.anchor_page_subdomain_status_text', data.anchor_page_subdomain_status_text)
                        this.changeSta(data.anchor_page_subdomain_status_text);
                        this.$store.state.user_data.merchant_account.cname_record = data.cname_record;
                        this.$store.state.user_data.merchant_account.anchor_page_subdomain = data.anchor_page_subdomain;
                        this.$store.state.user_data.merchant_account.redirect_url = data.redirect_url;
                        this.anchor_page_subdomain_temp = '';
                    }
                    this.start();
                    //this.$store.state.user_data.merchant_account.anchor_page_subdomain = this.domain_data.anchor_page_subdomain;
                    if (type === 'del') {
                        this.is_edit_subdomain = false;
                    }

                    this.pre_redirect_url = this.domain_data.redirect_url;
                    this.pre_main_domain = this.domain_data.main_domain;
                    this.is_edit_url = false;
                    this.is_loading = false;
                    this.key_refrash += 1;
                }).catch(err => {
                    this.errApiFun(err);
                    this.anchor_page_subdomain_temp = '';
                });
            }, 10);
        },

        retrySubdomainCheck() {
            this.is_loading = true;
            this.$ajax(`/settings/retry-anchor-page-subdomain-check`, {
                method: 'post'
            }).then(res => {
                this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + `Record  success.`);

                this.pushStatusText(res)
            }).catch(err => {
                this.errApiFun(err);
            });

        },

        setSubdomainCheck() {
            this.is_loading = true;
            this.$ajax(`/settings/set-domain-to-configuring`, {
                method: 'post'
            }).then(res => {
                this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + `Record  success.`);
                this.pushStatusText(res);
            }).catch(err => {
                this.errApiFun(err);
            });

        },

        pushStatusText(res) {
            if (res.data.data) {
                this.changeSta(res.data.data.anchor_page_subdomain_status_text);
            }
            this.is_loading = false;
            this.key_refrash += 1;
        },

        handleTableStatus() {
            if (this.status_text === this.status_text_list.cn_not_set) {
                this.setup_list[3].value = 'Not set up yet';
            } else {
                this.setup_list[3].value = this.status_text;
            };
        },

        errApiFun(err) {
            this.is_loading = false;
            if (err && err.response && err.response.data.data) {
                this.errNofity(err);
            }
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg>${mes}`);
        },
    },

    mounted() {
        this.is_merchant_host = this.$store.state.user_data.merchant_account.is_enable_merchant_host === 1 && !this.$store.state.merchant_disabeld ? true : false;
        //this.is_merchant_host = true;
        //this.status_text = this.status_text_list.work;
        this.start();
    },
}
</script>
<style lang="scss">
@mixin status($color) {
    content: '';
    height: 10px;
    width: 10px;
    display: block;
    background-color: $color;
    margin-right: 4px;
    border-radius: 50%;
}

.settings-domain-edit {
    //max-width: 820px;
    padding-right: 0 !important;

    .desc {
        margin: 8px 0 8px;
        font: var(--font-fg-14);
        color: var(--black-75);

        a {
            cursor: pointer;
        }
    }

    .ui-alert {
        margin: 0;
    }

    .domain {
        margin: 16px 0;
        padding: 16px;
        border: 1px solid #E0E0E0;
        border-radius: 8px;
        width: 100%;

        .el-button span{
            margin-right: unset !important;
        }

        &.is-dark {
            background-color: rgba(242, 242, 242, 1);
            opacity: .8;
        }

        &.can-edit {
            cursor: pointer;
        }

        &.is-loading {
            opacity: 0.5;
            pointer-events: none;
        }

        .label {
            font: var(--font-med-16);
            color: var(--black-90);
        }

        p {
            margin-top: 8px;
            font-family: var(--font);
            font-weight: 400;
            font-size: 14px;
            color: var(--black-75);

            &.black-text {
                color: var(--black-100);
                margin: 4px 0 16px;
            }
        }

        .info {
            margin-top: 19px;
            display: flex;
            align-items: center;
            font: var(--font-med-12);

            .url {
                flex: 1;
                font: var(--font-demi-12);
                color: var(--black-90);
            }

            .text {
                flex: 1;
                color: var(--black-50);
                font-size: 12px;
            }

            .right-info {
                display: flex;
                align-items: center;

                span {
                    margin-right: 8px;
                    font: var(--font-fg-12);
                    color: var(--black-90);
                    display: flex;
                    align-items: center;
                }

                .el-button span{
                    color:var(--white);
                }

                .for-subdomain-bottom {
                    display: flex;
                    align-items: center;

                    i {
                        margin-left: 4px;
                        border: solid 1px var(--dark-blue);
                    }

                    .ui-button {
                        border: solid 1px var(--dark-blue);
                    }
                }

            }

            .svg-icon--lock {
                height: 16px;
                width: 16px;
                display: block;
                fill: var(--black-50);
            }

            .edit {
                font-family: var(--font);
                font-weight: 600;
                font-size: 12px;
                color: var(--dark-blue);
                height: 30px;
                padding: 0 10px;
                line-height: 30px;
                border-radius: 20px;
                border: 1px solid var(--dark-blue);
                margin-left: 8px;
            }
        }
    }

    .domain-edit {
        background-color: var(--bg-10);
        border: none;

        &.is-loading {
            opacity: 0.5;
            pointer-events: none;
        }

        .label {
            display: flex;
            justify-content: space-between;
            align-items: center;

            svg {
                cursor: pointer;
            }
        }

        svg {
            width: 10px;
            height: 10px;
        }


        .err-msg {
            margin-top: -20px;
            margin-bottom: 16px;
            color: var(--alert);
            font-size: 12px;
            text-align: right;

            &::before {
                content: '*';
            }
        }

        .input {
            margin: 7px 0 24px 0;
            display: flex;
            align-items: center;

            input {
                padding: 11px 8px;
                flex: 1;
                border: 1px solid var(--black-20);
                background-color: white;
                width: 100%;
                border-radius: 6px;
                color: var(--black-90);
                transition: .15s border-color ease;
                font-weight: 500;
                font-family: var(--font);

                &:focus {
                    border-color: var(--blue);
                    outline: none;
                }

                &::placeholder {
                    color: var(--black-50);
                }
            }
        }

        .input-err {
            input {
                border-color: var(--alert);
            }
        }

        p {

            span {
                color: var(--blue);
                cursor: pointer;
            }

            strong {
                font: var(--font-fg-14);
                font-weight: 600;
            }

            &.hint {
                margin-top: 7px;
                font-size: 12px;
            }
        }



        .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .dis-connent {
            font: var(--font-med-14);
            color: var(--alert);
            font-weight: 400;
            margin-top: 8px;
            cursor: pointer;
        }
    }

    .domain-edit .fallback-dis-connent {
        margin-top: 0;
    }

    .domain-edit-small-box {
        padding: 16px;
        background-color: var(--white);
        margin: 16px 0;

        .sub-url {
            font: var(--font-med-14);
            color: var(--black-90);
        }

        p {
            font-size: 12px;
            color: var(--black-100);
            margin-top: 0px;
        }

        .domain-edit-small-box-bottom {
            display: flex;
            align-items: center;

            span {
                margin-right: 8px;
            }
        }
    }

    .info-yellow {
        background-color: var(--light-yellow);
        border-left: solid 3px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        margin-top: 8px !important;

        p {
            margin-right: 8px;
        }

        .ui-button {
            background-color: transparent;
            min-width: 137px;
        }
    }

    .peport {
        margin-top: 16px;
        color: var(--black-75);

        a {
            color: var(--blue);
            font: var(--font-med-14);
            cursor: pointer;
        }
    }

    .btn-wrap {
        margin: 16px 0 0;
        display: flex;
        align-items: center;
        justify-content: right;

        .color-white {
            background-color: transparent;
            margin-right: 8px;
        }

        .disabled {
            pointer-events: none;
        }
    }


}

.icon32 {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
        width: 10.6px;
        height: 10.6px;
        fill: var(--dark-blue);
    }
}

.detail {
    background: white;
    border-radius: 8px;
    width: 100%;

    .title {
        font: var(--font-med-14);
        margin-bottom: 2px;

        &:after {
            content: ' *';
            color: var(--alert);
        }
    }

    .value {
        margin: 0 !important;
        width: 100%;
    }

    ol {
        margin: 16px 0;
        list-style-type: decimal;
        font-size: 14px;

        li {
            display: list-item;
            margin-left: 20px;
            color: var(--black-75);
        }

    }

    p {
        margin-top: unset;
        color: var(--black-75);
    }

    .host-wrap {
        display: grid;
        grid-template-columns: 1fr 2fr 2fr 1fr;
        width: 100%;

        .value {

            label {
                font: var(--font-med-12);

            }

            .value-wrap {
                margin-top: 4px;
                padding: 6px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: var(--light-neutral);
                cursor: pointer;
                border-top: solid 1px var(--border);
                border-bottom: solid 1px var(--border);
                height: 40px;
                border-right: solid 1px var(--gray-blue);
            }



            &:last-child {
                .value-wrap {
                    border-right: none;
                }
            }

        }
    }
}

.p16-24 {
    padding: 24px 16px !important;
}

.red-dot-btn-in {
    margin-right: 10px !important;
}

.yellow-dot,
.green-dot,
.red-dot {
    display: grid;
    align-items: center;
    grid-template-columns: 14px 1fr;

    &::before {
        @include status(var(--yellow));
    }

    &.green-dot::before {
        @include status(var(--green));
    }

    &.red-dot::before {
        @include status(var(--alert));
    }
}

.required {
    &:after {
        content: ' *';
        color: var(--alert);
    }
}

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ui-alert {
    span {
        text-decoration: underline;
        text-decoration-color: var(--blue);
    }
}
</style>

